<template>
  <div class="top-menu">
    <el-row>
      <el-col :span="10">
        <div class="grid-content logo">
          <!-- <div class="title-img" style="width:49px;height:50px;margin-top:5px">
            <img src="@/assets/newImages/title.png" alt="排污许可核查" />
          </div> -->
          <!-- <div class="title-img" style="width:295px">
            <img src="@/assets/newImages/titletext.png" alt="排污许可核查" />
          </div> -->

          <!-- 暂时使用的 -->
          <!-- <div
            class="title-img"
            style="width: 49px; height: 50px; margin-top: 5px"
          >
            <img src="@/assets/newImages/title.png" alt="大兴生物医药产业基地智慧化危险废物管理平台" />
          </div> -->
          <span style="margin-left: 20px"
            >大兴生物医药产业基地智慧化危险废物管理平台</span
          >
          <!-- <i style="font-size: 20px; margin-left: 45px" :class="isCollapse ? 'el-icon-s-unfold' : 'el-icon-s-fold'"
            @click="isCollapseFlag()"></i> -->
        </div>
      </el-col>
      <el-col :span="14">
        <div class="grid-content right-box text-right">
          <!-- <el-popover placement="bottom" title="消息" width="200" trigger="click">
                        <p>暂无消息</p>
                        <el-badge :value="0" slot="reference" class="mark">
                            <i class="el-icon el-icon-message-solid"></i>
                        </el-badge>
                    </el-popover> -->

          <!-- <span class="edit-pwd" @click="editPassword()">
            <i class="el-icon el-icon-lock"></i>修改密码
          </span> -->
          <el-dropdown @command="handleCommand">
            <span class="el-dropdown-link" style="cursor: pointer">
              <i class="el-icon el-icon-user-solid"></i>
              {{ company }}
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="editPassword"
                >修改密码</el-dropdown-item
              >
              <el-dropdown-item
                command="editTel"
                v-auth="['Company', 'DealWith']"
                >修改手机号</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>

          <span class="top-logout" @click="logOut">
            <i class="el-icon el-icon-switch-button"></i>退出
          </span>
          <!-- <span @click="schermoCompleto">
            <i
              style="font-size: 26px; margin-left: 30px"
              class="el-icon el-icon-full-screen"
            ></i>
          </span> -->
        </div>
      </el-col>
      <!-- <el-col :span="2">
        <div class="go-back" @click="goIndex()">
          <i style="margin-right: 5px" class="iconfont icon-dengchu"></i>
          返回
        </div>
      </el-col> -->
    </el-row>

    <el-dialog
      title="修改手机号"
      :destroy-on-close="true"
      :close-on-click-modal="true"
      @close="close"
      :visible.sync="editTelDialogVisible"
      width="30%"
      append-to-body
    >
      <el-form
        ref="editTelForm"
        :model="formModel"
        :rules="rules"
        label-width="100px"
      >
        <el-row>
          <el-col :span="24">
            <el-form-item label="新手机号" prop="mobile">
              <el-input
                v-model="formModel.mobile"
                placeholder="请输入手机号"
                clearable
                :style="{ width: '100%' }"
              />
            </el-form-item>
          </el-col>

          <el-col :span="18">
            <el-form-item label="短信验证码" prop="checkcode">
              <el-input
                v-model="formModel.checkcode"
                placeholder="请输入短信验证码"
                clearable
                :style="{ width: '100%' }"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="" prop="field105" label-width="10px">
              <el-button
                type="primary"
                style="width: 100%"
                :disabled="disable"
                @click="getSmsCode"
                >{{ buttonName }}</el-button
              >
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="medium" @click="resetEditTelForm()">取 消</el-button>
        <el-button type="primary" size="medium" @click="submitEditTelForm"
          >确 定</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      title="修改登入密码"
      :destroy-on-close="true"
      :close-on-click-modal="true"
      @close="close"
      :visible.sync="centerDialogVisible"
      width="30%"
      append-to-body
    >
      <el-form
        ref="elForm"
        :model="passwordList"
        :rules="formRules"
        label-width="100px"
      >
        <el-form-item label="旧密码" prop="oldPassword">
          <el-input
            type="password"
            show-password
            v-model="passwordList.oldPassword"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input
            type="password"
            show-password
            v-model="passwordList.newPassword"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="confirmPassword">
          <el-input
            type="password"
            show-password
            v-model="passwordList.confirmPassword"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <!-- <el-col :span="24">
          <el-form-item label="email" prop="email">
            <el-input v-model="formModel.email" placeholder="请输入email" clearable :style="{ width: '100%' }" />
          </el-form-item>
        </el-col> -->
        <!-- <el-col :span="24">
          <el-form-item label="手机号" prop="mobile">
            <el-input disabled v-model="formModel.mobile" placeholder="请输入手机号" clearable :style="{ width: '100%' }" />
          </el-form-item>
        </el-col>
        <el-col :span="18">
          <el-form-item label="短信验证码" prop="checkcode">
            <el-input v-model="formModel.checkcode" placeholder="请输入短信验证码" clearable :style="{ width: '100%' }" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="" prop="field105" label-width="10px">
            <el-button type="primary" style="width: 100%" :disabled="disable" @click="getSmsCode">{{ buttonName
            }}</el-button>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="新密码" prop="password">
            <el-input v-model="formModel.password" placeholder="请输入新密码" clearable :style="{ width: '100%' }" />
          </el-form-item>
        </el-col> -->
        <!-- <el-form-item>
          <el-button type="primary" @click="submitForm()">提交</el-button>
          <el-button @click="resetForm('passwordList')">重置</el-button>
        </el-form-item> -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="medium" @click="resetForm()">取 消</el-button>
        <el-button type="primary" size="medium" @click="submitForm"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import qs from "qs";
import screenfull from "screenfull";
export default {
  name: "top-menu",

  data() {
    var checkPhone = (rule, value, callback) => {
      const phoneReg = /^1[3|4|5|7|8][0-9]{9}$/;
      if (phoneReg.test(value)) {
        callback();
      } else {
        callback(new Error("手机号格式不正确"));
      }
    };

    var checkPassWord = (rule, value, callback) => {
      // const mailReg = /^(?![A-z0-9]+$)(?![A-z~@*()_]+$)(?![0-9~@*()_]+$)([A-z0-9~@*()_]{6,})$/
      // 必须包含符号大小写字母数字
      if (value == this.passwordList.oldPassword) {
        callback(new Error("新密码不能与旧密码相同。"));
        return;
      }

      const regex1 =
        /^(?![A-z0-9]+$)(?=.[^%&',;=?$\x22])(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]).{6,20}$/;
      if (regex1.test(value)) {
        callback();
      } else {
        callback(
          new Error("密码长度为6~20位，必须包含大小写字母、符号、数字。")
        );
      }
    };

    var checkConfirmPassWord = (rule, value, callback) => {
      if (value != this.passwordList.newPassword) {
        callback(new Error("两次密码输入不一致。"));
      } else {
        callback();
      }
    };
    return {
      buttonName: "获取验证码",
      count: 120,
      disable: false,
      timeOut: null,
      formModel: {
        mobile: undefined,
        // email: undefined,
        checkcode: undefined,
        // password: undefined,
      },
      rules: {
        mobile: [
          {
            validator: checkPhone,
            required: true,
            // message: '请输入手机号',
            trigger: "blur",
          },
        ],
        // email: [
        //   {
        //     validator: checkEmail,
        //     // required: true,
        //     message: "请输入email",
        //     trigger: "blur",
        //   },
        // ],
        checkcode: [
          {
            required: true,
            message: "请输入短信验证码",
            trigger: "blur",
          },
        ],
        password: [
          {
            validator: checkPassWord,
            required: true,
            // message: '请输入密码111',
            trigger: "blur",
          },
        ],
        oldPassword: [
          {
            required: true,
            // message: '请输入密码111',
            trigger: "blur",
          },
        ],
        newPassword: [
          {
            validator: checkPassWord,
            required: true,
            // message: '请输入密码111',
            trigger: "blur",
          },
        ],
      },
      formRules: {
        oldPassword: [
          { required: true, message: "请输入旧密码", trigger: "blur" },
        ],
        newPassword: [
          { required: true, message: "请输入新密码", trigger: "blur" },
          { validator: checkPassWord, trigger: "blur" },
        ],
        confirmPassword: [
          { required: true, message: "请再次输入新密码", trigger: "blur" },
          { validator: checkConfirmPassWord, trigger: "blur" },
        ],
      },
      centerDialogVisible: false,
      editTelDialogVisible: false,
      passwordList: {
        oldPassword: "",
        newPassword: "",
        confirmPassword: "",
      },
      visible: false,
      company: "",
    };
  },
  computed: {
    // isCollapse() {
    //   return this.$store.state.isCollapse;
    // },
  },
  methods: {
    handleCommand(command) {
      if (typeof this[command] === "function") {
        this[command]();
      }
    },
    getSmsCode() {
      this.$refs["editTelForm"].validateField("mobile", (valid) => {
        if (valid !== "") return;
        this.$axios
          .get(
            this.$api.appUsers.sendSmsModifyMobile,
            { mobile: this.formModel.mobile },
            false
          )
          .then((res) => {
            if (res.data.code == 0) {
              this.$message({
                message: res.data.msg,
                type: "success",
                offset: 180,
              });
              this.timeOut = setInterval(() => {
                if (this.count < 1) {
                  this.disable = false;
                  this.buttonName = "获取验证码";
                  this.count = 120;
                  clearInterval(this.timeOut);
                } else {
                  this.disable = true;
                  this.buttonName = this.count-- + "s后重发";
                }
              }, 1000);
            }
          })
          .catch((err) => {
            console.log("失败");
          });
      });
    },
    goIndex() {
      this.$router.push({
        path: "/index",
        query: {},
      });
    },
    // 点击全屏方法
    schermoCompleto() {
      const element = document.getElementById("app");
      screenfull.toggle(element);
    },
    // isCollapseFlag() {
    //   this.$store.commit("isCollapseFlag", !this.isCollapse);
    // },

    exitSystem() {
      this.$axios
        .post(this.$api.logOut, true)
        .then((res) => {
          sessionStorage.removeItem("permission");
          sessionStorage.removeItem("tokenData");
          sessionStorage.removeItem("store");
          sessionStorage.removeItem("getMenuList");
          sessionStorage.removeItem("tabs");
          sessionStorage.removeItem("openKeys");

          this.$router.push("/login");
          this.$message({
            type: "success",
            message: "退出成功!",
          });
        })
        .catch((err) => {
          console.log("失败");
        });
    },
    logOut() {
      this.$confirm("此操作将退出登录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // console.log(this.$api.logOut);
          this.exitSystem();
          // sessionStorage.removeItem("tabs");
          // let tabsList = [
          //   {
          //     fullPath: "/zonghe",
          //     meta: {
          //       title: "综合展示平台",
          //       icon: "icon-shujuguanli",
          //       routerType: "",
          //       requireLogin: true,
          //       permissionPath: ["b"],
          //     },
          //     icon: "icon-shujuguanli",
          //     permissionPath: ["b"],
          //     requireLogin: true,
          //     routerType: "",
          //     title: "综合展示平台",
          //     path: "/zonghe",
          //   },
          // ];
          // this.$store.commit("saveTabsData", JSON.stringify(tabsList));
          // sessionStorage.removeItem("tokenData");
          // sessionStorage.removeItem("searchCityComm");
          // sessionStorage.removeItem("searchComm");
          // sessionStorage.removeItem("getMenuList");
          // sessionStorage.removeItem("screenComm");
          // sessionStorage.removeItem("permission");
          // this.$router.go(0);
          // this.$message({
          //   type: "success",
          //   message: "退出成功!",
          // });
        })
        .catch(() => {});
      // this.$axios
      //     .post(this.$api.logOut, true)
      //     .then(res => {
      //         sessionStorage.clear();
      //         this.$router.push("/login");
      //     })
      //     .catch(err => {
      //         console.log("失败");
      //     });
    },
    close() {
      clearInterval(this.timeOut);
      this.count = 120;
      this.buttonName = "获取验证码";
      this.disable = false;
      this.$nextTick(() => {
        this.$refs.elForm.resetFields(); // this.$refs.adduserform.resetFields();
      });
    },
    editPassword() {
      this.centerDialogVisible = true;
    },

    editTel() {
      this.editTelDialogVisible = true;
    },
    submitForm(formName) {
      this.$refs["elForm"].validate((valid) => {
        if (!valid) return;

        const { confirmPassword, ...postData } = this.passwordList;
        this.$axios
          .post(
            this.$api.appUsers.modifyPassWord,
            this.$qs.stringify(postData),
            false
          )
          .then((res) => {
            if (res.data.code == 0) {
              this.$message({
                message: res.data.msg,
                type: "success",
                offset: 180,
              });
              this.centerDialogVisible = false;
            }
          })
          .catch((err) => {
            console.log("失败");
          });
      });
    },
    submitEditTelForm(formName) {
      this.$refs["editTelForm"].validate((valid) => {
        if (!valid) return;

        const postData = this.formModel;
        this.$axios
          .post(
            this.$api.appUsers.modifyMobile,
            this.$qs.stringify(postData),
            false
          )
          .then((res) => {
            if (res.data.code == 0) {
              this.$message({
                message: res.data.msg,
                type: "success",
                offset: 180,
              });

              this.exitSystem();
              this.centerDialogVisible = false;
            }
          })
          .catch((err) => {
            console.log("失败");
          });
      });
    },
    resetForm() {
      this.$nextTick(() => {
        this.centerDialogVisible = false;
        this.$refs.elForm.resetFields(); // this.$refs.adduserform.resetFields();
      });
    },
    resetEditTelForm() {
      this.$nextTick(() => {
        this.editTelDialogVisible = false;
        this.$refs.editTelForm.resetFields(); // this.$refs.adduserform.resetFields();
      });
    },
  },
  created() {},
  beforeCreate: function () {
    //可以在这加个loading事件
    //console.group('beforeCreate 创建前状态===============》');
  },
  created: function () {
    //在这结束loading，还做一些初始化，实现函数自执行
    //console.group('created 创建完毕状态===============》');
  },
  beforeMount: function () {
    //console.group('beforeMount 挂载前状态===============》');
  },
  mounted: function () {
    //在这发起后端请求，拿回数据，配合路由钩子做一些事情
    //console.group('mounted 挂载结束状态===============》');
    let userName = JSON.parse(window.sessionStorage.getItem("tokenData")).name;
    this.company = userName;
    // this.formModel.mobile = JSON.parse(window.sessionStorage.getItem("tokenData")).mobile;
  },
  beforeUpdate: function () {
    //console.group('beforeUpdate 更新前状态===============》');
  },
  updated: function () {
    //console.group('updated 更新完成状态===============》');
  },
  beforeDestroy: function () {
    // 你确认删除XX吗？  当前组件已被删除，清空相关内容
    //console.group('beforeDestroy 销毁前状态===============》');
  },
  destroyed: function () {
    //console.group('destroyed 销毁完成状态===============》');
  },
};
</script>

<style lang="scss">
#nav-fixed {
  z-index: 999 !important;
}

.el-dropdown {
  color: #ffffff !important;
}

.el-popover {
  z-index: 2000 !important;
}

.top-menu {
  width: 100%;
  height: 100%;
  background-image: linear-gradient(to right, #067df9, #165dd4);
}

.el-row,
.el-col {
  height: 100%;
}

.width100 {
  width: 100px;
}

.grid-content {
  position: relative;
  top: 50%;
  transform: translateY(-50%);
  font-size: 14px;
  color: #ffffff;
  letter-spacing: 1px;
}

.right-box {
  padding-right: 10px;
  box-sizing: border-box;

  .edit-pwd {
    position: relative;
    display: inline-block;
    margin-left: 30px;
    padding-right: 20px;
    margin-right: 20px;
    cursor: pointer;

    &::after {
      content: "";
      position: absolute;
      z-index: 111;
      top: 0;
      right: 0;
      width: 1px;
      height: 100%;
      background-color: #ffffff;
    }
  }
}

.go-back {
  background: #ffb11a;
  width: 80%;
  float: right;
  height: 100%;
  line-height: 60px;
  color: #ffffff;
  font-size: 14px;
  text-align: center;
  cursor: pointer;
}

.logo {
  margin-left: 5px;
  height: 60px;
  /* width: 140px; */
  line-height: 60px;
}

.logo > img {
  width: 46px;
  height: 44px;
  margin-top: 8px;
  margin-right: 15px;
  float: left;
}

.logo span {
  font-size: 18px;
}

.el-icon {
  display: inline-block;
  margin-right: 10px;
  font-size: 16px;
}

.top-menu .el-icon-user-solid {
  border: 1px solid #ffffff;
  border-radius: 50%;
}

.top-welcome {
  padding-right: 25px;
  box-sizing: border-box;
  cursor: default;
}

.top-welcome::after {
  content: "";
  position: absolute;
  z-index: 111;
  top: 50%;
  right: 25px;
  width: 2px;
  height: 18px;
  transform: translateY(-50%);
  background-color: #ffffff;
}

.top-edit {
  padding-left: 25px;
  box-sizing: border-box;
  cursor: pointer;
}

.top-logout {
  cursor: pointer;
  margin-left: 25px;
  margin-right: 25px;
}

.text-right {
  text-align: right;
}

.title-img {
  line-height: normal;
  width: 61px;
  height: 39px;
  margin-top: 10px;
  margin-right: 15px;
  margin-left: 7px;
  float: left;
  // border-radius: 50%;
  overflow: hidden;
}

.title-img img {
  width: 100%;
  height: 100%;
  // transform: scale(1.2);
  // -ms-transform: scale(1.2);
}
</style>